/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const LoginPage = lazyLoad(
  () => import('./index'),
  module => module.LoginPage,
);

export const SsoCallback = lazyLoad(
  () => import('./SsoCallback'),
  module => module.SsoCallback,
);
